// extracted by mini-css-extract-plugin
export default {"breadcrumb":"BreadCrumb_breadcrumb__SFs5y","inner":"BreadCrumb_inner__fpkj-","home":"BreadCrumb_home__5iu43"};